import type { products } from "@/Models/MProduct/Products";
import type { MSubCategoryHijaSubcategory } from "@/Models/MSubCategories/MPLPCategory";
import { useDepartamentCategories } from "@/Service/Api/Index";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

type CategorieConstextType = {
  ProductsByCategory: MSubCategoryHijaSubcategory[];
  ProductsForCategory: products[];
  ProductColorsCategory: (subCategory: string) => void;
  IsLoadings: boolean;
  ListColorsDefault: string[];
  CategoriesDefault: string;
  UpdateSubCategories: string;
  HeanddleFilterBrandData: (name: string, checked: boolean) => void;
  HeanddleOrderTo: (event: number) => void;
  HeaddleRangePrice: (min: number, max: number) => void;
  SelectBrand: string[];
  VoidDefault: (categroriesList: string) => void;
  ViewProducts: boolean;
  //headlessSaveSubCategorie: (subCategories: string) => void;
};

export const CategoriesContext = React.createContext<
  CategorieConstextType | undefined
>(undefined);

const ContextCategorieProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  //sort by data mark - brand
  const [SelectBrand, setSelectBrand] = useState<string[]>([]);
  //sort by data column
  const [OrderToColumn, setOrderToColumn] = useState<number>(0);
  //sort by rank - range
  const [dataRange, setDataRange] = useState<[number, number]>([0, 50500]);
  ////set sub-categories
  //const [saveSubCategorie, setsaveSubCategorie] = useState<string>("");

  const [subCateg, setSubCateg] = useState<string>("");
  const [categories, setCategories] = useState<string>("tv-y-video");
  const [categoriesv2, setCategoriesv2] = useState<string>("tv-y-video");

  const { listCategory, isLoadin: IsLoadings } = useDepartamentCategories(
    categories === "tv-y-video" || categories === "" || categories === undefined
      ? "tv-y-video"
      : categories!
  );

  const VoidDefaultSearch = useCallback(
    (searchX: string) => {
      setCategoriesv2(searchX);
    },
    [listCategory]
  );

  const VoidDefault = (categoriesList: string) => {
    setCategories(categoriesList!);
  };

  const ProductsByCategory =
    listCategory.filter((f) => f.Products.length > 0) ?? [];

  const CategoriesDefault =
    ProductsByCategory?.flatMap((n) => n?.Name)[0] ?? "";

  const ViewProducts = ProductsByCategory.length > 0 ? true : false;

  const ProductColorsCategory = useCallback(
    (categoryId: string) => {
      // Buscar la categoría seleccionada
      const category = listCategory.find((c) => c.Name === categoryId);

      if (!category) return [];

      //se guarda la categoria a mostrar los datos.
      setSubCateg(categoryId!);

      // Extraer todos los colores de los productos dentro de esa categoría
      const colors = listCategory
        .find((c) => c?.Name === categoryId)
        ?.Products?.flatMap((promo) =>
          promo.Promotions.flatMap((c) => c.color)
        );

      const uniqueColors = [...new Set(colors)];

      return uniqueColors;
    },
    [listCategory]
  );

  //la nueva sub-Categoria o la que viene por defecto.
  const UpdateSubCategories =
    subCateg !== "" && subCateg !== null ? subCateg : CategoriesDefault;

  const forColorDataDefault = listCategory
    .find((c) => c?.Name === UpdateSubCategories)
    ?.Products?.flatMap((promo) => promo.Promotions.flatMap((c) => c.color));

  const ListColorsDefault = [...new Set(forColorDataDefault)];

  const ListaProductos: products[] = listCategory
    .filter(
      (f) => f.Name == UpdateSubCategories //CategoriesDefault
    )
    ?.flatMap((x) => x.Products);

  //filtramos por marcas
  const HeanddleFilterBrandData = (name: string, checked: boolean) => {
    setSelectBrand((prev) =>
      checked ? [...prev, name] : prev.filter((brands) => brands !== name)
    );
  };

  //filtramos por orden de precio
  const HeanddleOrderTo = (event: number) => {
    setOrderToColumn(event);
  };

  //filtramos por rango de precio
  const HeaddleRangePrice = useCallback((min: number, max: number) => {
    setDataRange([min, max]);
  }, []);

  // *** Filtramos los datos pr cada sección **
  // -- 1 ) Filtrado por coincidencia (marca, categoría, etc.)
  const filterForBrand = useMemo(() => {
    //verificamos que si contegamos datos.
    if (!ListaProductos || ListaProductos.length === 0) return [];

    // devolvemos si no tenemos seleccionado ningun dato
    if (SelectBrand.length === 0) return ListaProductos;

    //filtramos todos los datos posibles que coincidan.
    return ListaProductos.filter((item) =>
      SelectBrand.includes(item.Brand.trim().toLocaleLowerCase())
    );
  }, [ListaProductos, SelectBrand]);

  // -- 2 ) Filtrado por rango
  const FilterForRange = useMemo(() => {
    //verificamos que si contegamos datos.
    if (!ListaProductos || ListaProductos.length === 0) return [];

    //obtenemos el rango requerido
    const [min, max] = dataRange;

    //retornamos los datos que entre entre ese rango establedico
    return filterForBrand.filter((item) => {
      const values = Number(item["Price"]) || 0;
      return values >= min && values <= max;
    });
  }, [filterForBrand, dataRange]);

  // -- 3 ) Ordenamiento (mayor a menor, menor a mayor, etc.)
  const orderForData = useMemo(() => {
    //verificamos que si contegamos datos.
    if (!ListaProductos || ListaProductos.length === 0) return [];

    //ingresamos los datos para que sean ordenadas segun su :
    const sortedProducts = [...FilterForRange];
    switch (OrderToColumn) {
      case 1:
        return sortedProducts.sort((a, b) => b["Price"] - a["Price"]);
      case 2:
        return sortedProducts.sort((a, b) => a["Price"] - b["Price"]);
      case 3:
        return sortedProducts.sort(
          (a, b) => b["CBvAverageRating"] - a["CBvAverageRating"]
        );
      default:
        return [...FilterForRange];
    }
  }, [FilterForRange, OrderToColumn]);

  //se envia los datos para mostrar todo los productos ya filtrados.
  const ProductsForCategory = orderForData;

  //se vuelve por defecto si se hace cambios de sub-categoria
  useEffect(() => {
    //limpiamos las variable de estado.
    setSelectBrand([]); //brand - marca
    setDataRange([0, 50500]); // range - rango
    setOrderToColumn(0); //order to column - orderna segun su tipo.
  }, [UpdateSubCategories, IsLoadings]);

  return (
    <CategoriesContext.Provider
      value={{
        ProductColorsCategory,
        IsLoadings,
        ProductsByCategory,
        ListColorsDefault,
        CategoriesDefault,
        UpdateSubCategories,
        HeanddleFilterBrandData,
        HeanddleOrderTo,
        HeaddleRangePrice,
        SelectBrand,
        ProductsForCategory,
        VoidDefault,
        ViewProducts,
      }}>
      {children}
    </CategoriesContext.Provider>
  );
};

export default ContextCategorieProvider;

export const useConatextCategoriesData = () => {
  const context = useContext(CategoriesContext);
  if (!context)
    throw new Error(
      "useConatextCategoriesData must be used within a ContextCategorieProvider"
    );

  return context;
};
